export default {
  headerContent: {
    title: 'Sompo Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo  Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Sompo  Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası aracınızı beklenmedik kazalar sonucu oluşan hasar masraflarına karşı koruma sağlamaktadır.',
        'Kasko sigortası fiyatları; risk, yaş, cinsiyet, sürüş geçmişi ve araç türü dâhil ancak bunlarla sınırlı olmamak üzere bir dizi faktöre dayalı olarak istatistiksel olarak değerlendirilecektir.',
        'En dikkatli sürücü olabilirsiniz, ancak bu sizi yoldaki araba kazalarına karşı şanslı yapmayabilir. Hava durumu ve öngörülemeyen olaylar, her zaman savunmasız olduğunuz anlamına gelir.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'Kasko sigortası teminatları almış olduğunuz pakete göre değişmektedir. Genel olarak sunulan kasko teminatları:',
          subList: [
            'Anahtar kaybı',
            'Aracınızın çalınması',
            'Aracınızın çarpması ya da aracınıza çarpılması',
            'Aracınızın yanması',
            'Deprem',
            'Fırtına, dolu, yıldırım hasarları',
            'Kemirgen hayvan zararları',
            'Sel ve su baskını',
            'Aracın kullanımından doğabilecek anlaşmazlıklara bağlı hukuki masraflar',
            '7/24 yardım hizmetleri',
            'Sigara ve benzeri maddelerin aracınıza vereceği yangın dışındaki zararlar teminatı.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo  Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
